<template>
  <div>
    <!-- Trade In report -->
    <v-col cols="12">
      <MultiLineButton
        v-if="shootingType === 'INSPECTION'"
        :disabled="!reportTradeInExist"
        @click="downloadReport(tradeInOfferUrlPDF)"
        :text="$t('shooting.buttons.download.btnReportTradeIn')"
        :loading="downloadLoading"
      />
    </v-col>
    <!-- Inspection report -->
    <v-col cols="12">
      <MultiLineButton
        :disabled="!reportInspectExist"
        @click="downloadReport(tradeInspectUrlPDF)"
        :text="$t('shooting.buttons.download.btnReportInspection')"
        :loading="downloadLoading"
      />
    </v-col>
  </div>
</template>

<script>
import api from '@/script/api'
import { download } from '@/script/utils'
import MultiLineButton from '@/components/buttons/MultiLineButton.vue'

export default {
  name: 'DownloadReport',
  components: {
    MultiLineButton
  },
  props: {
    shootingId: String,
    registration: String,
    date: String,
    shootingType: String
  },
  data() {
    return {
      downloadLoading: false,
      reportTradeInExist: false,
      reportInspectExist: false,
      tradeInOfferUrlPDF: null,
      tradeInspectUrlPDF: null
    }
  },
  mounted() {
    this.ownerId = this.$route.params.ownerId
    this.productId = this.$route.params.productId

    if (this.shootingType === 'INSPECTION') {
      this.checkReportTradeInExist()
    }
    this.checkReportInspectExist()
  },
  methods: {
    _isErrorPdf(url) {
      return url === 'NO_PDF' || url === 'ERROR'
    },

    async checkReportTradeInExist() {
      const url = await api.getTradeInOfferUrlPdf(this.ownerId, this.productId, this.shootingId)

      this.reportTradeInExist = !this._isErrorPdf(url)
      if (!this.reportTradeInExist) return
      this.tradeInOfferUrlPDF = url
    },

    async checkReportInspectExist() {
      const url = await api.getInspectionReportUrlPdf(this.ownerId, this.productId, this.shootingId)

      this.reportInspectExist = !this._isErrorPdf(url)
      if (!this.reportInspectExist) return
      this.tradeInspectUrlPDF = url
    },

    async downloadReport(urlReport) {
      this.downloadLoading = true
      const fileName = `${this.date.replace(/\//gi, '-')}-${this.registration}.pdf`
      download(urlReport, fileName, true)
      this.downloadLoading = false
    },

    snackbarMessage(message, color) {
      this.$store.commit('SET_SNACKBAR', { snack: message, color: color })
    }
  }
}
</script>
